import { Skeleton } from '@/common/components/ui/skeleton';

export const OrgDetailPageSkeleton = () => (
  <div className="space-y-6 pb-10">
    <div>
      <Skeleton className="h-4 w-[130px] mb-4" />
      <div className="flex items-start gap-4">
        <Skeleton className="size-12 rounded-2xl shrink-0" />
        <div className="flex flex-col gap-1.5 pt-0.5">
          <Skeleton className="h-8 w-[240px]" />
          <Skeleton className="h-4 w-[160px]" />
        </div>
      </div>
    </div>
    <div>
      <div className="flex items-center gap-1 border-b border-border">
        <Skeleton className="h-[38px] w-28 rounded-t-sm" />
        <Skeleton className="h-[38px] w-24 rounded-t-sm" />
        <Skeleton className="h-[38px] w-20 rounded-t-sm" />
        <Skeleton className="h-[38px] w-24 rounded-t-sm" />
      </div>
      <div className="pt-4">
        <Skeleton className="h-[300px] rounded-2xl" />
      </div>
    </div>
  </div>
);
